

import {
  Compass,
  BookOpen,
  LifeBuoy,
  Info,
  Handshake,
  Gem,
  UserPlus,
  PlusCircle,
  FileText,
  User,
  LayoutGrid,
  MessageSquareWarning,
  Sparkles,
  Home,
  Briefcase,
  UserSearch,
  Building,
  ShieldCheck,
} from 'lucide-react';

export const mainNavLinks = [
  { href: '/', label: 'Trang chủ', icon: Home, mobile: true },
  { href: '/viec-lam', label: 'Việc làm' },
  // { href: '/lo-trinh', label: 'Lộ trình' },
  { href: '/quy-trinh', label: 'Quy trình' },
  // {
  //   href: '/tao-ho-so-ai',
  //   label: 'Tạo hồ sơ AI',
  //   icon: Sparkles,
  //   mobile: true,
  // },
  { href: '/cam-nang', label: 'Cẩm nang', icon: LifeBuoy, mobile: true },
  { href: '/gioi-thieu', label: 'Giới thiệu' },
];

export const quickAccessLinks = [
  // { href: '/lo-trinh', label: 'Lộ trình', icon: Compass },
  { href: '/quy-trinh', label: 'Quy trình', icon: Compass },
  { href: '/tu-van-vien', label: 'Tư vấn viên', icon: UserSearch },
  { href: '/nha-tuyen-dung', label: 'Nhà tuyển dụng', icon: Building },
  { href: '/bang-dieu-khien', label: 'Dữ liệu & Báo cáo', icon: FileText },
  { href: '/nhuong-quyen', label: 'Đối tác tại Nhật', icon: Handshake },
  { href: '/viec-lam-cua-toi', label: 'Việc của tôi', icon: Briefcase },
  { href: '/gop-y', label: 'Góp ý', icon: MessageSquareWarning },
  { href: '/nang-cap-premium', label: 'Nâng cấp Premium', icon: Gem },
  { href: '/gioi-thieu-ban-be', label: 'Giới thiệu bạn bè', icon: UserPlus },
  { href: '/dieu-khoan-chinh-sach', label: 'Điều khoản người dùng', icon: FileText },
  { href: '/chinh-sach-bao-mat', label: 'Chính sách bảo mật', icon: ShieldCheck },
  { href: '/giai-quyet-tranh-chap', label: 'Giải quyết tranh chấp', icon: Handshake },
];

// Re-ordered to a stable, logical order to fix hydration errors.
export const mobileFooterLinks = [
  { href: '/viec-lam', label: 'Việc làm', icon: Briefcase },
  // { href: '/lo-trinh', label: 'Lộ trình', icon: Compass },
  { href: '/quy-trinh', label: 'Quy trình', icon: Compass },
  { href: '/tao-ho-so-ai', label: 'Hồ sơ AI', icon: Sparkles },
  { href: '/cam-nang', label: 'Cẩm nang', icon: LifeBuoy },
  { href: '/tu-van-vien', label: 'Tư vấn viên', icon: UserSearch },
  { href: '/gioi-thieu', label: 'Giới thiệu', icon: Info },
];
